import {isCordovaApp} from "../analytics/analytics";
import {createBrowserHistory, createHashHistory} from "history";
import { useMemo } from "react";
// Since cordova runs js files using file:// protocol,
// use hash router for cordova
export const useCreateHistory = () => {
    return useMemo(
        () => (isCordovaApp() ? createHashHistory() : createBrowserHistory()),
        [],
    );
}
